// extracted by mini-css-extract-plugin
export default {"match-event":"match-event--WoaufTKSRf","matchEvent":"match-event--WoaufTKSRf"};